// extracted by mini-css-extract-plugin
export default {"btn":"AdminMobileSortToggleBtn_btn__SKPCg"};